const NotFound = () => {

    return(
        <div className="h-screen w-screen flex flex-col justify-center items-center">
            <h1 className=" text-3xl text-white text-center">NotFound :) Hit <a className="hover:text-white/50 transition-all duration-500 ease-in-out" target='_self' href="/">back</a> button</h1><br/>
        </div>
    )
}

export default NotFound;